import { CommissionBonusDetailResponse, CommissionBonusDetailsPageResponse } from "../../../domain/models/integration/commission-bonus-details.model";

type UnknownRecord = Record<string, unknown>;
const isRecord = (value: unknown): value is UnknownRecord => typeof value === "object" && value !== null && !Array.isArray(value);
const isNullableString = (value: unknown): value is string | null => value === null || typeof value === "string";
const isNullableNumber = (value: unknown): value is number | null => value === null || (typeof value === "number" && Number.isFinite(value));
const isNumber = (value: unknown): value is number => typeof value === "number" && Number.isFinite(value);

const isDetail = (value: unknown): value is CommissionBonusDetailResponse =>
  isRecord(value) && isNullableString(value["id"]) && isNullableNumber(value["bonusId"]) &&
  isNullableNumber(value["sponsorId"]) && isNullableString(value["sponsorName"]) &&
  isNullableString(value["sponsorLastName"]) && isNullableString(value["sponsorUsername"]) &&
  isNullableNumber(value["newMemberId"]) && isNullableString(value["newMemberName"]) &&
  isNullableString(value["newMemberLastName"]) && isNullableNumber(value["levelSponsor"]) &&
  isNullableString(value["bonusType"]) && isNullableString(value["membership"]) &&
  isNullableNumber(value["amount"]) && isNullableString(value["cycleDate"]) &&
  isNullableNumber(value["periodId"]) && isNullableNumber(value["paidStatus"]) &&
  isNullableString(value["status"]) && isNullableNumber(value["saleAmount"]) &&
  isNullableString(value["payDate"]) && isNullableString(value["range"]) &&
  isNullableNumber(value["amountPaid"]) && isNullableNumber(value["difference"]);

export function isCommissionBonusDetailsPageResponse(value: unknown): value is CommissionBonusDetailsPageResponse {
  return isRecord(value) && Array.isArray(value["content"]) && value["content"].every(isDetail) &&
    isNumber(value["page"]) && isNumber(value["size"]) && isNumber(value["totalElements"]) && isNumber(value["totalPages"]);
}
